export interface ParameterConfig {
  type: string;
  label: string;
  default?: any;
  description?: string;
  required?: boolean;
  options?: string[] | Record<string, string>;
  readonly?: boolean;
  section?: string;
  min?: number;
  max?: number;
  minLength?: number;
  maxLength?: number;
}

export interface ParameterTemplate {
  [key: string]: ParameterConfig;
}

export interface WorkflowSchema {
  activity_definitions: Record<string, {
    name: string;
    description: string;
    parameter_schema: ParameterTemplate;
    example_config: any;
  }>;
  condition_definitions: Record<string, {
    name: string;
    description: string;
    example: any;
  }>;
  activity_types: string[];
  condition_types: string[];
  trigger_types: string[];
}

export const DEFAULT_PARAMETER_TEMPLATES: Record<string, ParameterTemplate> = {
};